'use client';


/** Imports */
import React from 'react';
import Script from 'next/script';
import NextError from 'next/error';
import {isProduction} from '@/modules/utils';


/** Component */
export default function GlobalError() {
    /**
     * `NextError` is the default Next.js error page component.
     * Its type definition requires a `statusCode` prop.
     * However, since the App Router does not expose status codes for errors,
     * we simply pass 0 to render a generic error message.
     */
    return (
        <html lang="en">

            {/* Head */}
            <head>
                <title>
                    MediaFox - Social Media Suite
                </title>
                <meta name="google" content="notranslate"/>

                {/* Cookiebot */}
                {isProduction && (
                    <Script
                        id="Cookiebot"
                        src="https://consent.cookiebot.com/uc.js"
                        data-cbid="9fed508c-9492-42a9-aaf9-90b83a4f2e5a"
                        data-blockingmode="auto"
                        strategy="beforeInteractive"
                    />
                )}
            </head>

            {/* Content */}
            <body>
                <NextError statusCode={0}/>
            </body>
        </html>
    );
}
